import React, { useState, useEffect } from 'react';
import logo from '../images/logo.png';
import { useNavigate } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './css/Login.css';
import API from '../api/axiosInstance';

const Login = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [message, setMessage] = useState('');
  const [captchaValue, setCaptchaValue] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Drop auto-login leftovers before admin signs in
    sessionStorage.removeItem('personId');

    // App.js auth reads sessionStorage. A localStorage-only token would
    // bounce /admin-login ↔ / forever (white screen).
    const token = sessionStorage.getItem('token');
    if (token) navigate('/');
  }, [navigate]);

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleCaptchaChange = (value) => setCaptchaValue(value);

  const handleSubmit = async (e) => {
        e.preventDefault();

        if (!captchaValue) {
          setMessage('Please complete the reCAPTCHA');
          return;
        }

        setIsSubmitting(true);

        try {
          const res = await API.post('/auth/admin-login', {
            ...formData,
            captcha: captchaValue,
          });

          const { token, username, role } = res.data;

          if (!token) {
            setMessage("Login failed — token not received.");
            setIsSubmitting(false);
            return;
          }

          localStorage.setItem("token", token);
          localStorage.setItem("username", username);
          localStorage.setItem("role", role);

          sessionStorage.setItem("token", token);
          sessionStorage.setItem("username", username);
          sessionStorage.setItem("role", role);

          setMessage("Login successful");
          navigate("/");
        } catch (err) {
          console.error("Login error:", err);
          setMessage(err?.response?.data?.msg || "Invalid credentials");
        } finally {
          setIsSubmitting(false);
        }
      };

  return (
    <div className="login-page bk-img">
      <div className="form-content">
        <div className="container">
          <div className="row d-flex align-items-center justify-content-center vh-100">
            <div className="col-md-6 login-box">
              <h1 className="text-center pt-2x">
                <img src={logo} width="150" alt="Logo" />
              </h1>
              <h1 className="text-center text-bold">Admin Login</h1>
              <div className="well row pt-2x pb-3x bk-light">
                <div className="col-md-8 offset-md-2">
                  <form onSubmit={handleSubmit}>
                      <div className="form-group mb-3">
                        <input
                          type="text" // Changed from email to text
                          name="email"
                          className="form-control"
                          placeholder="Enter your username or email" // Updated placeholder
                          value={formData.email}
                          onChange={handleChange}
                          required
                        />
                      </div>

                    <div className="form-group mb-3 position-relative">
                      <input
                        type={showPassword ? 'text' : 'password'}
                        name="password"
                        className="form-control pe-5"
                        placeholder="Enter your password"
                        value={formData.password}
                        onChange={handleChange}
                        required
                      />
                      <i
                      className={`bi ${showPassword ? 'bi-eye' : 'bi-eye-slash'}
                        position-absolute top-50 end-0 translate-middle-y me-3`}
                      style={{ cursor: "pointer", fontSize: "1.2rem" }}
                      onClick={() => setShowPassword(!showPassword)}
                    ></i>
                    </div>

                    <div className="login-recaptcha-wrapper">
                      <ReCAPTCHA
                        sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY || 'your_site_key_here'}
                        onChange={handleCaptchaChange}
                      />
                    </div>

                    <button type="submit" className="btn btn-warning btn-block mt-3" disabled={isSubmitting}>
                      {isSubmitting ? 'Logging in...' : 'Login'}
                    </button>

                    {message && (
                      <div
                        className={`alert mt-3 ${
                          message === 'Login successful' ? 'alert-success' : 'alert-danger'
                        }`}
                      >
                        {message}
                      </div>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
